module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921075649_T.8d6c123e.jpg";